import { instance } from "libs/api";

import { ApiRoutesPacks } from "../../constants";
import { Pack } from "../../packs.types";
import { CreatePackRequestBody } from "./createPack.types";

export const requestCreatePack = async (
  body: CreatePackRequestBody
): Promise<Pack> => {
  return await instance.post(ApiRoutesPacks.Packs, body);
};
